import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { Input } from './Input';
import { Payout } from './PayoutCard';
interface EditPayoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (payout: Payout) => void;
  payout: Payout | null;
}
export function EditPayoutModal({
  isOpen,
  onClose,
  onSave,
  payout
}: EditPayoutModalProps) {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [notes, setNotes] = useState('');
  useEffect(() => {
    if (payout) {
      setAmount(payout.amount.toString());
      setDate(payout.date);
      setNotes(payout.notes || '');
    }
  }, [payout]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!payout || !amount) return;
    onSave({
      ...payout,
      amount: parseFloat(amount),
      date,
      notes: notes || undefined
    });
    onClose();
  };
  if (!payout) return null;
  return <AnimatePresence data-id="element-342" data-mp="2k7v9uo4sggiz">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-343" data-mp="2f88wmeoyn0a6" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-344" data-mp="32ws4wu80fd29">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 my-8" data-id="element-345" data-mp="1dkzoibrpi9q1">
              <div className="flex items-center justify-between mb-6" data-id="element-346" data-mp="3cphrn8vlpzkt">
                <h2 className="text-2xl font-semibold text-stone-900" data-id="element-347" data-mp="3hn00kz9mcest">
                  Rediger udbetaling
                </h2>
                <button onClick={onClose} className="text-stone-400 hover:text-stone-600 transition-colors" aria-label="Luk" data-id="element-348" data-mp="3mnxh77ezd0s7">
                  <XIcon className="w-6 h-6" data-id="element-349" data-mp="3vk6dwebkplan" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-350" data-mp="4dv9c87cu2ek">
                <Input label="Beløb (kr)" type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} placeholder="f.eks. 5000" required data-id="element-351" data-mp="97zhuvw9qihr" />

                <Input label="Dato" type="date" value={date} onChange={e => setDate(e.target.value)} required data-id="element-352" data-mp="n78uxmp6gwhi" />

                <div data-id="element-353" data-mp="23ozk2klebz1a">
                  <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-354" data-mp="1ynsdgouzp5w7">
                    Noter
                  </label>
                  <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Tilføj noter om denne udbetaling" rows={3} className="w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none" data-id="element-355" data-mp="1tpqus51h78l9" />
                </div>

                <div className="flex gap-3 pt-2" data-id="element-356" data-mp="3a40h6tm5qn9g">
                  <Button type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-357" data-mp="3a4s4lh5lpeon">
                    Annuller
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1" data-id="element-358" data-mp="2twvqf157o0mi">
                    Gem ændringer
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}